import useConfigureRevenueCat from '@/src/modules/pricing/hooks/useConfigureRevenueCat';
import { useIsRevenueCatAvailable } from '@/src/modules/pricing/hooks/useIsRevenueCatAvailable';
import { pricingQueryKeys } from '@/src/modules/pricing/queries/pricingQueryKeys';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import type { PurchasesOfferings } from '@revenuecat/purchases-capacitor';
import { Purchases } from '@revenuecat/purchases-capacitor';
import type { QueryObserverOptions } from '@tanstack/react-query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const useQueryRevenueCatOfferings = (
  queryOptions?: Partial<QueryObserverOptions<PurchasesOfferings>>,
) => {
  const configureRevenueCat = useConfigureRevenueCat();
  const isRevenueCatAvailable = useIsRevenueCatAvailable();

  return useQuery({
    queryKey: pricingQueryKeys.revenueCatOfferings(),
    queryFn: async () => {
      if (!isRevenueCatAvailable) throw new Error('RevenueCat is not available');

      if (!(await configureRevenueCat())) {
        throw new Error('RevenueCat could not be configured');
      }

      return Purchases.getOfferings();
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
    enabled: isQueryEnabled([queryOptions?.enabled, isRevenueCatAvailable]),
  });
};

export default useQueryRevenueCatOfferings;
